import Swal, { type SweetAlertOptions } from 'sweetalert2';

const baseConfig: SweetAlertOptions = {
  background: '#131932',
  color: '#e6e8ef',
  buttonsStyling: false,
  customClass: {
    popup: 'draw-swal-popup',
    confirmButton: 'draw-swal-btn draw-swal-confirm',
    cancelButton: 'draw-swal-btn draw-swal-cancel',
    icon: 'draw-swal-icon',
    title: 'draw-swal-title',
    htmlContainer: 'draw-swal-html',
  },
};

export async function confirmDialog(opts: {
  title: string;
  text?: string;
  confirmText: string;
  cancelText: string;
  danger?: boolean;
}): Promise<boolean> {
  const result = await Swal.fire({
    ...baseConfig,
    title: opts.title,
    text: opts.text,
    icon: opts.danger ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonText: opts.confirmText,
    cancelButtonText: opts.cancelText,
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      ...baseConfig.customClass,
      confirmButton: `draw-swal-btn ${opts.danger ? 'draw-swal-danger' : 'draw-swal-confirm'}`,
    },
  });
  return result.isConfirmed;
}

export function alertDialog(opts: {
  title: string;
  text?: string;
  icon?: 'success' | 'error' | 'warning' | 'info';
}): Promise<unknown> {
  return Swal.fire({
    ...baseConfig,
    title: opts.title,
    text: opts.text,
    icon: opts.icon,
  });
}
